import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { useApi } from 'components/providers/ApiProvider'
import { useMessage } from 'components/elements/Message'
import * as yup from 'yup'
import useFormal from '@kevinwolf/formal-web'
import { Grid, Paper } from '@material-ui/core'
import { TextField } from 'components/elements/TextField'
import { SubmitButton } from 'Elements/SubmitButton'
import { Add } from '@material-ui/icons'

export interface GrantAccessFormData {
  id: number
}

export type Props = {
  data: GrantAccessFormData
}
export type Functions = {
  onSuccess(): void
}
export type AllProps = Props & Functions

const GrantAccessForm: FunctionComponent<AllProps> = ({ data, onSuccess }) => {
  const { t } = useTranslation()
  const api = useApi()
  const { showSuccess, showError } = useMessage()

  const initialValues = {
    client: '',
  }

  const schema = yup.object().shape({
    client: yup.string().trim().matches(/^[0-9a-zA-Z.]{1,30}$/),
  })

  const formal = useFormal(initialValues, {
    schema,
    onSubmit: async values => {
      values = schema.cast(values)

      await api.grantReservationOfferAccess({
        offer_id: data.id,
        client: values.client,
      })
        .then(data => {
          if (!data || !data.status) {
            throw new Error
          }

          formal.change('client', initialValues.client)
          formal.clearErrors()

          onSuccess()

          showSuccess(t('messages.reservationOfferAccessGranted'))
        })
        .catch(error => {
          let message

          switch (error.code) {
            case 3:
              message = t('alerts.checkInput')
              break
            case 710:
              message = t('alerts.reservationOfferAccessAlreadyGranted')
              break
            default:
              message = t('alerts.tryLater')
          }

          showError(`${t('alerts.couldNotGrantReservationOfferAccess')} ${message}`)
        })
    },
  })

  return (
    <form {...formal.getFormProps()} noValidate>
      <Paper variant="outlined" style={{ padding: 16, marginBottom: 32 }}>
        <Grid container spacing={1}>
          <TextField
            GridProps={{ style: { flex: 1 } }}
            label={t('client')}
            helperText={t('clientPhoneNumberOrUsernameHelperText')}
            required
            size="small"
            {...formal.getFieldProps('client')}
          />
          <SubmitButton
            GridProps={{ style: { boxSizing: 'content-box', height: 40 } }}
            buttonText={t('add')}
            startIcon={<Add />}
            size="small"
            disabled={formal.isSubmitting}
          />
        </Grid>
      </Paper>
    </form>
  )
}

export default GrantAccessForm
